export class ProcedureDocument {
    id: string;
    name: string;
    contentType: string;
    documentType: string;
    entryDate: string;
    content: any;

    constructor(other ?: ProcedureDocument) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.contentType = other.contentType;
            this.documentType = other.documentType;

            this.entryDate = other.entryDate;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/ProcedureDocument.ts
 **/